import React, { useEffect, useState } from 'react'
import TopBarWrapper from '../../../TopBarWrapper/TopBarWrapper'
import { connect } from 'react-redux'
import styled from 'styled-components'
import AvailableOfflineSection from "../../../Profile/Components/AvailableOfflineSection/AvailableOfflineSection";
import { hideBackArrow } from "../../../../../actions/ui";
import { OfflineColor, White } from "../../../../Constants/ColorChart";

/*
 *  @Description:   Component that renders the content.
 */

const StyledOffline = styled.div`
    position: fixed;
    top: 50px;
    background: ${ OfflineColor };
    width: 100%;
    color: ${ White };
    text-align: center;
    z-index:1;
`

const AvailableOfflineWrapper = styled.div`
    position: relative;
    top: 75px;
    & > div {
        margin: unset;
        width: 100%;
    }
`

const OfflineHome = ( props ) => {
    const { isNetworkAvailable/*, isServerReachable*/ } = props;
    const canConnect = isNetworkAvailable //&& isServerReachable;

    const [ title, setTitle ] = useState ( null );

    const changeTitle = ( str ) => {
        setTitle ( str );
    }

    useEffect ( () => {
        props.hideBackArrow ();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <div className={ "contentContainer" }>
            {
                !canConnect &&
                <StyledOffline>OFFLINE</StyledOffline>
            }
            <TopBarWrapper title={ title }/>
            <AvailableOfflineWrapper className={ "container" }>
                <AvailableOfflineSection changeTitle={ changeTitle }/>
            </AvailableOfflineWrapper>
        </div>
    )
}

const mapStateToProps = ( state ) => ( {
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
    session: state.session,
} )

export default connect ( mapStateToProps, {
    hideBackArrow,
} ) ( OfflineHome );